var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkroutzUrl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6562 0.950001H2.21875C1.44344 0.950001 0.8125 1.58935 0.8125 2.375V10.925C0.8125 11.7106 1.44344 12.35 2.21875 12.35H10.6562C11.4316 12.35 12.0625 11.7106 12.0625 10.925V2.375C12.0625 1.58935 11.4316 0.950001 10.6562 0.950001ZM10.1875 6.65C10.1875 6.91267 9.97797 7.125 9.71875 7.125C9.45953 7.125 9.25 6.91267 9.25 6.65V4.7025L5.22578 8.7799C5.13438 8.87252 5.01438 8.91908 4.89437 8.91908C4.77437 8.91908 4.65438 8.873 4.5625 8.7799C4.37922 8.59417 4.37922 8.29397 4.5625 8.10825L8.815 3.8H6.4375C6.17828 3.8 5.96875 3.58768 5.96875 3.325C5.96875 3.06233 6.17828 2.85 6.4375 2.85H10.1875V6.65Z",
    fill: "#B6B7E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkroutzUrl);
export default __webpack_public_path__ + "static/media/Skroutz_Url.85d4b600.svg";
export { ForwardRef as ReactComponent };